import profileEditComponent from './profile-edit.component';

const profileEditModule = angular.module('profileEdit', [])
  .component('profileEdit', profileEditComponent)
  .name;

export default profileEditModule;
